/**
 * @license @tabler/icons-react v3.10.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */

import createReactComponent from '../createReactComponent.mjs';

var IconAlignBoxBottomRight = createReactComponent("outline", "align-box-bottom-right", "IconAlignBoxBottomRight", [["path", { "d": "M3 3m0 2a2 2 0 0 1 2 -2h14a2 2 0 0 1 2 2v14a2 2 0 0 1 -2 2h-14a2 2 0 0 1 -2 -2z", "key": "svg-0" }], ["path", { "d": "M11 15v2", "key": "svg-1" }], ["path", { "d": "M14 11v6", "key": "svg-2" }], ["path", { "d": "M17 13v4", "key": "svg-3" }]]);

export { IconAlignBoxBottomRight as default };
//# sourceMappingURL=IconAlignBoxBottomRight.mjs.map
